import React from 'react';
import useTranslate from '../../../../customHooks/useTranslate';

const TypeAdditionalInfo = () => {
    const translate = useTranslate();

    return (
        <div>
            <p className='text-size-12 '>
                <span className='font-weight-600'>
                    {translate('exclusive')}:{' '}
                </span>
                <span className='font-weight-400'>
                    {translate('exclusive_description')}
                </span>
            </p>
            <p className='text-size-12 '>
                <span className='font-weight-600'>
                    {translate('inclusive')}:{' '}
                </span>
                <span className='font-weight-400'>
                    {translate('inclusive_description')}
                </span>
            </p>
        </div>
    );
};

export default TypeAdditionalInfo;
